import styled from "styled-components";
import { MainHeader } from "./Header";
import { useState } from "react";
import { ClusterTourProvider } from "@/components/ui/tour";
import { useAuth } from "../hooks/useAuth";
import { MainAdminMenu } from "./Roles/Admin.Menu";
import { MainUserMenu } from "./Roles/User.Menu";
import { LoginForm } from "../components/Auth/LoginForm";
import type { CardMessageType } from "../pages/LoginPage";
import { Dialog, DialogContent } from "../components/ui/dialog";
import { Card } from "../components/Shared/Card";
import { ToastContainer } from "react-toastify";

export function MainLayout(props: { children: React.ReactNode }) {
	const [cardMessage, setCardMessage] = useState<CardMessageType>(null);

	const auth = useAuth();
	const rol = auth.user?.userType;
	const expired = auth.auth == null || auth.auth.refresh_token === "EXPIRED";

	return (
		<div className="sidebarLayout grid grid-rows-[var(--header-height)_auto]">
			<div style={{ display: "flex" }}>
				<MainHeader />
			</div>
			{rol == "ADMIN" ? <MainAdminMenu /> : <MainUserMenu />}
			<Content className={`content`}>
				<ClusterTourProvider>{props.children}</ClusterTourProvider>

				<Dialog open={expired} onOpenChange={() => {}}>
					<DialogContent
						description="La sesión ha expirado o no se ha iniciado sesión. Por favor, inicia sesión de nuevo."
						style={{ backgroundColor: "white" }}
					>
						<h1 className="grid grid-cols-2 gap-10 m-auto">
							<img src="/img/Logo_Cluster_Completo.svg" className="h-30"></img>
							<img src="/img/Logo_Wunder_Completo.svg" className="h-30"></img>
						</h1>
						{cardMessage != null && (
							<Card
								className={`max-w-md mt-5 text-wrap border-l-4 border-solid ${"border-" + cardMessage.type}`}
							>
								{/* Ensure the css classes are loaded */}
								<div className="border-info border-error border-warning border-success" />
								<div id="login_error">{cardMessage.msg}</div>
							</Card>
						)}
						<LoginForm
							setCardMessage={setCardMessage}
							setIsResetting={null}
							onSuccess={() => {}}
						/>
					</DialogContent>
				</Dialog>
			</Content>
			<ToastContainer />
		</div>
	);
}

const Content = styled.div`
	display: flex;
	position: absolute;
	top: var(--header-height);
	left: calc(var(--sidebar-icons-width) + var(--sidebar-text-width));
	right: 0;
	bottom: 0;
	transition: transform 0.3s ease-in-out;
	background-color: rgb(240, 240, 240);

	> div {
		flex: 1;
	}
`;
